// Only share pending reads. Completed responses and errors are never cached.
const reads = new Map<string, Promise<any>>();
export function coalesceRead<T>(key: string, load: () => Promise<T>): Promise<T> {
  const existing = reads.get(key);
  if (existing) return existing;
  const request = Promise.resolve().then(load).finally(() => {
    if (reads.get(key) === request) reads.delete(key);
  });
  reads.set(key, request);
  return request;
}
